import React, { useState } from 'react';
import { 
  DeleteForever, 
} from '@mui/icons-material';

import BaseButton from './BaseButton';
import ModalOrDrawer from '@components/display/ModalOrDrawer';
import FlexBox from '@components/layout/FlexBox';
import DandDButtonBox from '@dndComponents/DandDButtonBoxSimple';

interface Props extends React.ComponentPropsWithoutRef<'div'> {
  disabled?: boolean;
  obj_name?: string;
  label?: string;
  label_separate?: boolean;
  no_fab?: boolean;
  fab?: boolean;
  confirm_message?: string;
  confirm?: boolean;
  log_it?: boolean;
  onClick: (event: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement> | undefined) => void;
  onMouseDown?: (event: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement>) => void;
}

export default function DeleteButton(props: Props) {
  const [confirm_open, setConfirmOpen] = useState(false);

  const renderExtras = () => {
    const obj_name = props.obj_name;
    const confirm_message = props.confirm_message ? props.confirm_message : `Are you sure you want to delete ${ !obj_name || obj_name === "" ? "this" : obj_name}? This cannot be undone.`;
    return (
      <>
        <ModalOrDrawer open={confirm_open} onClose={() => setConfirmOpen(false) }>
          <FlexBox direction="column">
            <FlexBox>{confirm_message}</FlexBox>
            <FlexBox>
              <div style={{ float: "right", width: "200px" }}>
                <FlexBox direction="row">
                  <FlexBox>
                    <DandDButtonBox name="Delete" color="red" onClick={ async () => {
                      props.onClick(undefined);
                    }}/>
                  </FlexBox>
                  <FlexBox>
                    <DandDButtonBox name="Cancel" onClick={() => {
                      setConfirmOpen(false);
                    }}/>
                  </FlexBox>
                </FlexBox>
              </div>
            </FlexBox>
          </FlexBox>
        </ModalOrDrawer>
      </>
    )
  }

  const handleClick = () => {
    if (props.confirm || props.obj_name) {
      setConfirmOpen(true);
    } else {
      props.onClick(undefined);
    }
  }

  const pass_along_props = {...props} as any;
  delete pass_along_props.confirm_message;
  delete pass_along_props.confirm;
  delete pass_along_props.onClick;
  if (props.fab === undefined && props.no_fab === undefined) {
    pass_along_props.fab = true;
  }

  return (
    <>
      <BaseButton
        icon={<DeleteForever />}
        onClick={handleClick}
        {...pass_along_props}
      />
      { renderExtras() }
    </>
  );
}
